import { GruppeTier } from '../../gruppe-tier/classes/gruppe-tier';

export class AbgabebelegPosition {
    aa_id: number;
    abgabebeleg_id: number;
    position: number;
    artikel_id: number;
    artikel: string;
    artikel_me: string;
    tierart_id: number;
    tierart: string;
    anzahl_tiere: number;
    tiergewicht: string;
    anwendungsdauer: number;
    anwendungsdauer_txt: string;
    dosierung: number;
    artikelmenge: number;
    artikelmenge_ist: number;
    verpackungsmenge: number;
    chargen: PositionCharge[] = [];
    indikation_id: number;
    diagnose: string;
    identifikation: string;
    anwendung_id: number;
    anwendung: string;
    ean: number;
    wartezeit: number;
    behandlung: number;
    abgabeundbehandlung: number;
    anwendungsdauer_fix: number;
    dosierung_fix: number;
    chargeJN: number;
    einzelpreis: number;
    status_id_meldung: number;
    status_meldung: string;
    status_fehler: string;
    meldung_gemeldet: Date;
    impfung: number;
    tiere: GruppeTier[] = [];
    mengenartikel: number;
    aus_stueckliste: number;
    stueckliste: number;
    gruppe: string;
    herdenname: string;
    stall: string;
    gruppe_id: number;
    datum: Date;
    dosierung_txt: string;
    dosierung_tierart: number;
    koerpergewicht_tierart: number;
    prophylaxe: number;
    metaphylaxe: number;
    umwidmung: number;
    status_id_hit: number;
    status_hit: string;
    fehler_hit: string;
    gemeldet_hit: Date;
    status_id_qs: number;
    status_qs: string;
    fehler_qs: string;
    gemeldet_qs: Date;
    sonderfall: number;
    erstellt: Date;
    einzelpreis_editor: string;
    abrechnen: number; // vom Backend
}

export class PositionCharge {
    aa_id: number;
    ac_id: number;
    charge: string;
    charge_id: number;
    chargenmenge: number;
    mhd: Date;
    lagerplatz_id: number;
}
